import { render, staticRenderFns } from "./RestaurantFavoriteCard.vue?vue&type=template&id=961ee96c&scoped=true&"
import script from "./RestaurantFavoriteCard.vue?vue&type=script&lang=js&"
export * from "./RestaurantFavoriteCard.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantFavoriteCard.vue?vue&type=style&index=0&id=961ee96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961ee96c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VImg,VRating})
